
import './App.css';
import './main-page.css';
import RoutesComponent from './Routes';
// import MainPage from './components/mainpage';
import Routes from './Routes';

function App() {
  return (
    <div className="App">
     <RoutesComponent />


    </div>
  );
}

export default App;
